import React, { memo } from 'react';
export function EmotionalTransition() {
  return <section className="bg-blue-900 py-16 md:py-24 px-4" data-id="element-55">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-56">
        <p className="text-xl md:text-2xl text-blue-100 leading-relaxed" data-id="element-57">
          Se ti sei sentito frustrato perché i tuoi studenti non avanzano come
          dovrebbero, sappi che non dipende dal tuo talento musicale. Molto
          spesso il vero problema è la mancanza di un sistema di insegnamento
          chiaro, coinvolgente e facile da applicare.
        </p>

        <p className="text-2xl md:text-3xl text-white font-bold leading-relaxed" data-id="element-58">
          La verità è che oggi non basta conoscere bene la musica per essere un
          insegnante memorabile. Serve un metodo capace di mantenere alta
          l'attenzione, stimolare la pratica e trasformare ogni lezione in
          un'esperienza che lo studente desidera continuare.
        </p>

        <p className="text-xl text-blue-200 leading-relaxed" data-id="element-59">
          Ed è proprio qui che tutto cambia: quando inizi a insegnare con una
          struttura più intelligente, le lezioni diventano più semplici da
          preparare, gli studenti partecipano di più e i risultati iniziano
          finalmente a vedersi davvero.
        </p>
      </div>
    </section>;
}